import './App.scss';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import BackToTopButton from './components/BackToTopButton';
import Home from './components/Home';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import ArtStudio from './components/ArtStudio';
import InfinityYogaStudio from './component projects/InfinityYogaStudio';

function App() {
  return (
    <HelmetProvider>
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/artstudio" element={<ArtStudio />} />
          <Route path="/infinityyogastudio" element={<InfinityYogaStudio />} />
        </Routes>
        <Footer />
        <BackToTopButton />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;